// Backwards-compatible wrapper — delegates to useDeviceCapabilities
import { useDeviceCapabilities } from './use-device-capabilities';

export function useIsMobile() {
  return useDeviceCapabilities().isMobile;
}
